webpackJsonp([114276838955818,60335399758886],{

/***/ 1304:
/***/ (function(module, exports) {

	module.exports = {"layoutContext":{}}

/***/ }),

/***/ 1528:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(1642);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _layoutIndex = __webpack_require__(1304);
	
	var _layoutIndex2 = _interopRequireDefault(_layoutIndex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_index2.default, _extends({}, props, _layoutIndex2.default));
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 76:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	var ArrowDropDown = function ArrowDropDown(_ref) {
	  var size = _ref.size,
	      color = _ref.color,
	      props = _objectWithoutProperties(_ref, ["size", "color"]);
	
	  return _react.default.createElement("svg", _extends({}, props, {
	    viewBox: "0 0 24 24",
	    width: size,
	    height: size,
	    fill: color
	  }), _react.default.createElement("path", {
	    d: "M7 10l5 5 5-5z"
	  }));
	};
	
	ArrowDropDown.displayName = "ArrowDropDown";
	ArrowDropDown.defaultProps = {
	  size: 24,
	  color: "currentcolor"
	};
	var _default = ArrowDropDown;
	exports.default = _default;

/***/ }),

/***/ 77:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	var Close = function Close(_ref) {
	  var size = _ref.size,
	      color = _ref.color,
	      props = _objectWithoutProperties(_ref, ["size", "color"]);
	
	  return _react.default.createElement("svg", _extends({}, props, {
	    viewBox: "0 0 24 24",
	    width: size,
	    height: size,
	    fill: color
	  }), _react.default.createElement("path", {
	    d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
	  }));
	};
	
	Close.displayName = "Close";
	Close.defaultProps = {
	  size: 24,
	  color: "currentcolor"
	};
	var _default = Close;
	exports.default = _default;

/***/ }),

/***/ 68:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	var Dehaze = function Dehaze(_ref) {
	  var size = _ref.size,
	      color = _ref.color,
	      props = _objectWithoutProperties(_ref, ["size", "color"]);
	
	  return _react.default.createElement("svg", _extends({}, props, {
	    viewBox: "0 0 24 24",
	    width: size,
	    height: size,
	    fill: color
	  }), _react.default.createElement("path", {
	    d: "M2 15.5v2h20v-2H2zm0-5v2h20v-2H2zm0-5v2h20v-2H2z"
	  }));
	};
	
	Dehaze.displayName = "Dehaze";
	Dehaze.defaultProps = {
	  size: 24,
	  color: "currentcolor"
	};
	var _default = Dehaze;
	exports.default = _default;

/***/ }),

/***/ 89:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	var Instagram = function Instagram(_ref) {
	  var size = _ref.size,
	      color = _ref.color,
	      props = _objectWithoutProperties(_ref, ["size", "color"]);
	
	  return _react.default.createElement("svg", _extends({}, props, {
	    viewBox: "0 0 1792 1792",
	    width: size,
	    height: size,
	    fill: color
	  }), _react.default.createElement("path", {
	    d: "M1339.32,769q-.35-25.31-2.11-67.85t-7-72.42q-5.28-29.88-13-50.28a184.1,184.1,0,0,0-102.65-102.65q-20.4-7.74-50.28-13t-72.42-7q-42.54-1.76-67.85-2.11t-74.18,0Q900.92,454,896,454t-53.79-.35q-48.87-.35-74.18,0t-67.85,2.11q-42.54,1.75-72.42,7t-50.28,13A184.1,184.1,0,0,0,474.83,578.48q-7.74,20.4-13,50.28t-7,72.42Q453,743.72,452.68,769t0,74.18Q453,892.08,453,897t-.35,53.79q-.35,48.87,0,74.18t2.11,67.85q1.75,42.54,7,72.42t13,50.28a184.1,184.1,0,0,0,102.65,102.65q20.4,7.74,50.28,13t72.42,7q42.54,1.76,67.85,2.11t74.18,0q48.87-.35,53.79-.35t53.79.35q48.87.35,74.18,0t67.85-2.11q42.54-1.76,72.42-7t50.28-13a184.1,184.1,0,0,0,102.65-102.65q7.74-20.4,13-50.28t7-72.42q1.76-42.54,2.11-67.85t0-74.18Q1339,901.92,1339,897t.35-53.79Q1339.67,794.34,1339.32,769Zm-247.15,324.14Q1011.32,1174,896,1174t-196.17-80.86Q619,1012.32,619,897t80.86-196.17Q780.68,620,896,620t196.17,80.86Q1173,781.68,1173,897T1092.17,1093.17ZM1230,654.42q-19,19-45.7,19t-45.7-19q-19-19-19-45.7t19-45.7q19-19,45.7-19t45.7,19q19,19,19,45.7T1230,654.42ZM1023.27,769.73Q1076,822.47,1076,897t-52.73,127.27Q970.53,1077,896,1077t-127.27-52.73Q716,971.53,716,897t52.73-127.27Q821.47,717,896,717T1023.27,769.73ZM1579.5,212.5Q1495,128,1376,128H416q-119,0-203.5,84.5T128,416v960q0,119,84.5,203.5T416,1664h960q119,0,203.5-84.5T1664,1376V416Q1664,297,1579.5,212.5Zm-147,907.39q-7,146.25-87.18,226.41t-226.41,87.18Q1057,1437,896,1437t-222.89-3.52q-146.25-7-226.41-87.18t-87.18-226.41Q356,1058,356,897t3.52-222.89q7-146.25,87.18-226.41t226.41-87.18Q735,357,896,357t222.89,3.52q146.25,7,226.41,87.18t87.18,226.41Q1436,736,1436,897T1432.48,1119.89Z"
	  }));
	};
	
	Instagram.displayName = "Instagram";
	Instagram.defaultProps = {
	  size: 24,
	  color: "currentcolor"
	};
	var _default = Instagram;
	exports.default = _default;

/***/ }),

/***/ 1878:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _reactJss = _interopRequireWildcard(__webpack_require__(47));
	
	var _merge = _interopRequireDefault(__webpack_require__(2951));
	
	var _globalPadding;
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var colors = {
	  primary: "#f15953",
	  primaryDark: "#d24f45",
	  primaryGlow: "#d24f45",
	  // todo
	  secondary: "#55c3ba",
	  secondaryDark: "#44b0a7",
	  tertiary: "#2e7fc2",
	  quaternary: "#ffc629",
	  white: "#fff",
	  gray050: "#fbfcfd",
	  gray100: "#edf1f4",
	  gray200: "#dde2e7",
	  gray300: "#ccd2d8",
	  gray400: "#b3bac1",
	  gray500: "#888f96",
	  gray600: "#60686f",
	  gray700: "#4b565f",
	  gray800: "#5a5b5c",
	  gray900: "#232c35",
	  black: "#11181e",
	  error: "#9c2929",
	  facebook: "#3b5998",
	  google: "#db4437",
	  linkedin: "#007bb5",
	  pinterest: "#bd081c",
	  twitter: "#1da1f2"
	};
	var alertColors = {
	  error: {
	    color: "#9c2929",
	    backgroundColor: "#fcf2f2",
	    borderColor: "#f6dddd"
	  },
	  info: {
	    color: "#0c5460",
	    backgroundColor: "#d1ecf1",
	    borderColor: "#bee5eb"
	  },
	  success: {
	    color: "#246761",
	    backgroundColor: "#ecf8f7",
	    borderColor: "#d2e8e6"
	  },
	  warning: {
	    color: "#856404",
	    backgroundColor: "#fff3cd",
	    borderColor: "#ffeeba"
	  }
	};
	var typography = {
	  bodyColor: "#2E2E35",
	  fontFamily: "'Open Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif",
	  fontSize: "1rem"
	};
	var transitions = {
	  default: "all 200ms linear"
	};
	var breakpoints = {
	  600: "@media (min-width: 600px)",
	  900: "@media (min-width: 900px)",
	  1200: "@media (min-width: 1200px)",
	  tabletPortrait: "@media (min-width: 600px)",
	  // todo: deprecate (check existing code for usage)
	  tabletLandscape: "@media (min-width: 900px)",
	  // todo: deprecate (check existing code for usage)
	  desktop: "@media (min-width: 1200px)" // todo: deprecate (check existing code for usage)
	
	};
	var globalBorderRadius = "4px";
	var globalBoxShadow = "0 2px 5px 0 rgba(0,0,0,0.16), 0 2px 10px 0 rgba(0,0,0,0.12)";
	var globalPadding = (_globalPadding = {
	  padding: "12px"
	}, _defineProperty(_globalPadding, breakpoints.tabletPortrait, {
	  padding: "16px"
	}), _defineProperty(_globalPadding, breakpoints.tabletLandscape, {
	  padding: "20px"
	}), _defineProperty(_globalPadding, breakpoints.desktop, {
	  padding: "24px"
	}), _globalPadding);
	var defaultTheme = {
	  alertColors: alertColors,
	  breakpoints: breakpoints,
	  colors: colors,
	  globalBorderRadius: globalBorderRadius,
	  globalBoxShadow: globalBoxShadow,
	  globalPadding: globalPadding,
	  transitions: transitions,
	  typography: typography
	};
	var GlobalsAndReset = (0, _reactJss.default)(function (theme) {
	  return {
	    "@global": {
	      /* Eric Meyer Reset v2.0 */
	
	      /* https://meyerweb.com/eric/tools/css/reset/ */
	      "html, body, div, span, applet, object, iframe, h1, h2, h3, h4, h5, h6, p, blockquote, pre, a, abbr, acronym, address, big, cite, code, del, dfn, em, img, ins, kbd, q, s, samp, small, strike, strong, sub, sup, tt, var, b, u, i, center, dl, dt, dd, ol, ul, li, fieldset, form, label, legend, table, caption, tbody, tfoot, thead, tr, th, td, article, aside, canvas, details, embed, figure, figcaption, footer, header, hgroup, menu, nav, output, ruby, section, summary, time, mark, audio, video": {
	        margin: "0",
	        padding: "0",
	        border: "0",
	        fontSize: "100%",
	        font: "inherit",
	        verticalAlign: "baseline"
	      },
	      "article, aside, details, figcaption, figure, footer, header, hgroup, menu, nav, section": {
	        display: "block"
	      },
	      body: {
	        lineHeight: "1"
	      },
	      "ol, ul": {
	        listStyle: "none"
	      },
	      "blockquote, q": {
	        quotes: "none"
	      },
	      "blockquote:before, blockquote:after, q:before, q:after": _defineProperty({
	        content: "''"
	      }, "content", "none"),
	      table: {
	        borderCollapse: "collapse",
	        borderSpacing: "0"
	      },
	
	      /* Globals */
	      "html, body": {
	        width: "100%",
	        minHeight: "100%",
	        fontFamily: theme.typography.fontFamily || "sans-serif",
	        fontSize: theme.typography.fontSize || "1rem",
	        fontWeight: "500",
	        color: theme.typography.bodyColor || "#000",
	        backgroundColor: "#fafafa",
	        "-webkit-font-smoothing": "antialiased",
	        "-moz-osx-font-smoothing": "grayscale",
	        margin: "0",
	        padding: "0"
	      },
	
	      /* Box-sizing border-box */
	
	      /* https://www.paulirish.com/2012/box-sizing-border-box-ftw/ */
	      html: {
	        boxSizing: "border-box",
	        background: "transparent"
	      },
	      "*, *:before, *:after": {
	        boxSizing: "inherit"
	      },
	
	      /* Reset `button` to nothing */
	
	      /* https://gist.github.com/chrisheninger/a860f87ef4e529b2df606768b97665a8 */
	      button: {
	        display: "inline-block",
	        "-webkit-appearance": "none",
	        "-moz-appearance": "none",
	        userSelect: "none",
	        textDecoration: "none",
	        fontFamily: "inherit",
	        fontSize: "inherit",
	        color: "inherit",
	        cursor: "pointer",
	        border: "none",
	        backgroundColor: "transparent",
	        borderColor: "transparent",
	        padding: "0",
	        margin: "0",
	        "&:disabled": {
	          opacity: 0.6,
	          cursor: "not-allowed"
	        }
	      }
	    }
	  };
	})(function (_ref) {
	  var children = _ref.children;
	  return children;
	});
	
	var ThemeProvider = function ThemeProvider(_ref2) {
	  var children = _ref2.children,
	      theme = _ref2.theme,
	      _ref2$withReset = _ref2.withReset,
	      withReset = _ref2$withReset === void 0 ? true : _ref2$withReset,
	      rest = _objectWithoutProperties(_ref2, ["children", "theme", "withReset"]);
	
	  var mergedTheme = theme ? (0, _merge.default)(defaultTheme, theme) : defaultTheme;
	  return _react.default.createElement(_reactJss.ThemeProvider, _extends({
	    theme: mergedTheme
	  }, rest), withReset ? _react.default.createElement(GlobalsAndReset, null, children) : children);
	};
	
	var _default = ThemeProvider;
	exports.default = _default;

/***/ }),

/***/ 1471:
/***/ (function(module, exports, __webpack_require__) {

	var baseAssignValue = __webpack_require__(1134),
	    eq = __webpack_require__(144);
	
	/**
	 * This function is like `assignValue` except that it doesn't assign
	 * `undefined` values.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function assignMergeValue(object, key, value) {
	  if ((value !== undefined && !eq(object[key], value)) ||
	      (value === undefined && !(key in object))) {
	    baseAssignValue(object, key, value);
	  }
	}
	
	module.exports = assignMergeValue;


/***/ }),

/***/ 2862:
/***/ (function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(1200),
	    assignMergeValue = __webpack_require__(1471),
	    baseFor = __webpack_require__(1474),
	    baseMergeDeep = __webpack_require__(2863),
	    isObject = __webpack_require__(60),
	    keysIn = __webpack_require__(1140),
	    safeGet = __webpack_require__(1494);
	
	/**
	 * The base implementation of `_.merge` without support for multiple sources.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @param {number} srcIndex The index of `source`.
	 * @param {Function} [customizer] The function to customize merged values.
	 * @param {Object} [stack] Tracks traversed source values and their merged
	 *  counterparts.
	 */
	function baseMerge(object, source, srcIndex, customizer, stack) {
	  if (object === source) {
	    return;
	  }
	  baseFor(source, function(srcValue, key) {
	    stack || (stack = new Stack);
	    if (isObject(srcValue)) {
	      baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
	    }
	    else {
	      var newValue = customizer
	        ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
	        : undefined;
	
	      if (newValue === undefined) {
	        newValue = srcValue;
	      }
	      assignMergeValue(object, key, newValue);
	    }
	  }, keysIn);
	}
	
	module.exports = baseMerge;


/***/ }),

/***/ 2863:
/***/ (function(module, exports, __webpack_require__) {

	var assignMergeValue = __webpack_require__(1471),
	    cloneBuffer = __webpack_require__(1479),
	    cloneTypedArray = __webpack_require__(1480),
	    copyArray = __webpack_require__(1316),
	    initCloneObject = __webpack_require__(1489),
	    isArguments = __webpack_require__(1208),
	    isArray = __webpack_require__(46),
	    isArrayLikeObject = __webpack_require__(1499),
	    isBuffer = __webpack_require__(1209),
	    isFunction = __webpack_require__(1323),
	    isObject = __webpack_require__(60),
	    isPlainObject = __webpack_require__(2946),
	    isTypedArray = __webpack_require__(1325),
	    safeGet = __webpack_require__(1494),
	    toPlainObject = __webpack_require__(2960);
	
	/**
	 * A specialized version of `baseMerge` for arrays and objects which performs
	 * deep merges and tracks traversed objects enabling objects with circular
	 * references to be merged.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @param {string} key The key of the value to merge.
	 * @param {number} srcIndex The index of `source`.
	 * @param {Function} mergeFunc The function to merge values.
	 * @param {Function} [customizer] The function to customize assigned values.
	 * @param {Object} [stack] Tracks traversed source values and their merged
	 *  counterparts.
	 */
	function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
	  var objValue = safeGet(object, key),
	      srcValue = safeGet(source, key),
	      stacked = stack.get(srcValue);
	
	  if (stacked) {
	    assignMergeValue(object, key, stacked);
	    return;
	  }
	  var newValue = customizer
	    ? customizer(objValue, srcValue, (key + ''), object, source, stack)
	    : undefined;
	
	  var isCommon = newValue === undefined;
	
	  if (isCommon) {
	    var isArr = isArray(srcValue),
	        isBuff = !isArr && isBuffer(srcValue),
	        isTyped = !isArr && !isBuff && isTypedArray(srcValue);
	
	    newValue = srcValue;
	    if (isArr || isBuff || isTyped) {
	      if (isArray(objValue)) {
	        newValue = objValue;
	      }
	      else if (isArrayLikeObject(objValue)) {
	        newValue = copyArray(objValue);
	      }
	      else if (isBuff) {
	        isCommon = false;
	        newValue = cloneBuffer(srcValue, true);
	      }
	      else if (isTyped) {
	        isCommon = false;
	        newValue = cloneTypedArray(srcValue, true);
	      }
	      else {
	        newValue = [];
	      }
	    }
	    else if (isPlainObject(srcValue) || isArguments(srcValue)) {
	      newValue = objValue;
	      if (isArguments(objValue)) {
	        newValue = toPlainObject(objValue);
	      }
	      else if (!isObject(objValue) || isFunction(objValue)) {
	        newValue = initCloneObject(srcValue);
	      }
	    }
	    else {
	      isCommon = false;
	    }
	  }
	  if (isCommon) {
	    // Recursively merge objects and arrays (susceptible to call stack limits).
	    stack.set(srcValue, newValue);
	    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
	    stack['delete'](srcValue);
	  }
	  assignMergeValue(object, key, newValue);
	}
	
	module.exports = baseMergeDeep;


/***/ }),

/***/ 2884:
/***/ (function(module, exports, __webpack_require__) {

	var baseRest = __webpack_require__(1314),
	    isIterateeCall = __webpack_require__(1319);
	
	/**
	 * Creates a function like `_.assign`.
	 *
	 * @private
	 * @param {Function} assigner The function to assign values.
	 * @returns {Function} Returns the new assigner function.
	 */
	function createAssigner(assigner) {
	  return baseRest(function(object, sources) {
	    var index = -1,
	        length = sources.length,
	        customizer = length > 1 ? sources[length - 1] : undefined,
	        guard = length > 2 ? sources[2] : undefined;
	
	    customizer = (assigner.length > 3 && typeof customizer == 'function')
	      ? (length--, customizer)
	      : undefined;
	
	    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	      customizer = length < 3 ? undefined : customizer;
	      length = 1;
	    }
	    object = Object(object);
	    while (++index < length) {
	      var source = sources[index];
	      if (source) {
	        assigner(object, source, index, customizer);
	      }
	    }
	    return object;
	  });
	}
	
	module.exports = createAssigner;


/***/ }),

/***/ 1319:
/***/ (function(module, exports, __webpack_require__) {

	var eq = __webpack_require__(144),
	    isArrayLike = __webpack_require__(80),
	    isIndex = __webpack_require__(1204),
	    isObject = __webpack_require__(60);
	
	/**
	 * Checks if the given arguments are from an iteratee call.
	 *
	 * @private
	 * @param {*} value The potential iteratee value argument.
	 * @param {*} index The potential iteratee index or key argument.
	 * @param {*} object The potential iteratee object argument.
	 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
	 *  else `false`.
	 */
	function isIterateeCall(value, index, object) {
	  if (!isObject(object)) {
	    return false;
	  }
	  var type = typeof index;
	  if (type == 'number'
	        ? (isArrayLike(object) && isIndex(index, object.length))
	        : (type == 'string' && index in object)
	      ) {
	    return eq(object[index], value);
	  }
	  return false;
	}
	
	module.exports = isIterateeCall;


/***/ }),

/***/ 1494:
/***/ (function(module, exports) {

	/**
	 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function safeGet(object, key) {
	  if (key === 'constructor' && typeof object[key] === 'function') {
	    return;
	  }
	
	  if (key == '__proto__') {
	    return;
	  }
	
	  return object[key];
	}
	
	module.exports = safeGet;


/***/ }),

/***/ 2946:
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(103),
	    getPrototype = __webpack_require__(1317),
	    isObjectLike = __webpack_require__(73);
	
	/** `Object#toString` result references. */
	var objectTag = '[object Object]';
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to infer the `Object` constructor. */
	var objectCtorString = funcToString.call(Object);
	
	/**
	 * Checks if `value` is a plain object, that is, an object created by the
	 * `Object` constructor or one with a `[[Prototype]]` of `null`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.8.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 * }
	 *
	 * _.isPlainObject(new Foo);
	 * // => false
	 *
	 * _.isPlainObject([1, 2, 3]);
	 * // => false
	 *
	 * _.isPlainObject({ 'x': 0, 'y': 0 });
	 * // => true
	 *
	 * _.isPlainObject(Object.create(null));
	 * // => true
	 */
	function isPlainObject(value) {
	  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
	    return false;
	  }
	  var proto = getPrototype(value);
	  if (proto === null) {
	    return true;
	  }
	  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
	    funcToString.call(Ctor) == objectCtorString;
	}
	
	module.exports = isPlainObject;


/***/ }),

/***/ 2951:
/***/ (function(module, exports, __webpack_require__) {

	var baseMerge = __webpack_require__(2862),
	    createAssigner = __webpack_require__(2884);
	
	/**
	 * This method is like `_.assign` except that it recursively merges own and
	 * inherited enumerable string keyed properties of source objects into the
	 * destination object. Source properties that resolve to `undefined` are
	 * skipped if a destination value exists. Array and plain object properties
	 * are merged recursively. Other objects and value types are overridden by
	 * assignment. Source objects are applied from left to right. Subsequent
	 * sources overwrite property assignments of previous sources.
	 *
	 * **Note:** This method mutates `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.5.0
	 * @category Object
	 * @param {Object} object The destination object.
	 * @param {...Object} [sources] The source objects.
	 * @returns {Object} Returns `object`.
	 * @example
	 *
	 * var object = {
	 *   'a': [{ 'b': 2 }, { 'd': 4 }]
	 * };
	 *
	 * var other = {
	 *   'a': [{ 'c': 3 }, { 'e': 5 }]
	 * };
	 *
	 * _.merge(object, other);
	 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
	 */
	var merge = createAssigner(function(object, source, srcIndex) {
	  baseMerge(object, source, srcIndex);
	});
	
	module.exports = merge;


/***/ }),

/***/ 2960:
/***/ (function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(1137),
	    keysIn = __webpack_require__(1140);
	
	/**
	 * Converts `value` to a plain object flattening inherited enumerable string
	 * keyed properties of `value` to own properties of the plain object.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {Object} Returns the converted plain object.
	 * @example
	 *
	 * function Foo() {
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.assign({ 'a': 1 }, new Foo);
	 * // => { 'a': 1, 'b': 2 }
	 *
	 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
	 * // => { 'a': 1, 'b': 2, 'c': 3 }
	 */
	function toPlainObject(value) {
	  return copyObject(value, keysIn(value));
	}
	
	module.exports = toPlainObject;


/***/ }),

/***/ 1142:
/***/ (function(module, exports) {

	(function(root) {
	  var isOn = false;
	  var scrollbarSize;
	  var scrollTop;
	
	  function getScrollbarSize() {
	    if (typeof scrollbarSize !== 'undefined') return scrollbarSize;
	
	    var doc = document.documentElement;
	    var dummyScroller = document.createElement('div');
	    dummyScroller.setAttribute('style', 'width:99px;height:99px;' + 'position:absolute;top:-9999px;overflow:scroll;');
	    doc.appendChild(dummyScroller);
	    scrollbarSize = dummyScroller.offsetWidth - dummyScroller.clientWidth;
	    doc.removeChild(dummyScroller);
	    return scrollbarSize;
	  }
	
	  function hasScrollbar() {
	    return document.documentElement.scrollHeight > window.innerHeight;
	  }
	
	  function on(options) {
	    if (typeof document === 'undefined' || isOn) return;
	    var doc = document.documentElement;
	    scrollTop = window.pageYOffset;
	    if (hasScrollbar()) {
	      doc.style.width = 'calc(100% - '+ getScrollbarSize() +'px)';
	    } else {
	      doc.style.width = '100%';
	    }
	    doc.style.position = 'fixed';
	    doc.style.top = -scrollTop + 'px';
	    doc.style.overflow = 'hidden';
	    isOn = true;
	  }
	
	  function off() {
	    if (typeof document === 'undefined' || !isOn) return;
	    var doc = document.documentElement;
	    doc.style.width = '';
	    doc.style.position = '';
	    doc.style.top = '';
	    doc.style.overflow = '';
	    window.scroll(0, scrollTop);
	    isOn = false;
	  }
	
	  function toggle() {
	    if (isOn) {
	      off();
	      return;
	    }
	    on();
	  }
	
	  var noScroll = {
	    on: on,
	    off: off,
	    toggle: toggle,
	  };
	
	  if (typeof module !== 'undefined' && typeof module.exports !== 'undefined') {
	    module.exports = noScroll;
	  } else {
	    root.noScroll = noScroll;
	  }
	})(this);


/***/ }),

/***/ 1237:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(15);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _classnames = __webpack_require__(4);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _withStyles = __webpack_require__(3);
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	var _Container = __webpack_require__(5);
	
	var _Container2 = _interopRequireDefault(_Container);
	
	var _elevate_tagw = __webpack_require__(81);
	
	var _elevate_tagw2 = _interopRequireDefault(_elevate_tagw);
	
	var _siteConfig = __webpack_require__(7);
	
	var _siteConfig2 = _interopRequireDefault(_siteConfig);
	
	var _SocialLinks = __webpack_require__(160);
	
	var _SocialLinks2 = _interopRequireDefault(_SocialLinks);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Footer = function Footer(_ref) {
	  var classes = _ref.classes;
	  return _react2.default.createElement(
	    "div",
	    { className: classes.root },
	    _react2.default.createElement(
	      _Container2.default,
	      null,
	      _react2.default.createElement(
	        "div",
	        { className: classes.grid },
	        _react2.default.createElement(
	          "div",
	          { className: (0, _classnames2.default)(classes.column, classes.logo) },
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: "/" },
	            _react2.default.createElement(
	              "div",
	              { style: { width: "170px", paddingBottom: "30px" } },
	              _react2.default.createElement("img", { src: _elevate_tagw2.default, width: "100%" })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: classes.column },
	          _react2.default.createElement(
	            "div",
	            { className: classes.section },
	            "Products"
	          ),
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { className: classes.link, to: "/elevate_at_a_glance" },
	            "Elevate At-A-Glance"
	          ),
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { className: classes.link, to: "/socialpro" },
	            "Social Pro\xAE"
	          ),
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { className: classes.link, to: "/elevatedms" },
	            "DMS\xAE"
	          ),
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { className: classes.link, to: "/dmsplus" },
	            "DMS PLUS\xAE"
	          ),
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { className: classes.link, to: "/elite" },
	            "Elite\xAE"
	          ),
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { className: classes.link, to: "/elitepro" },
	            "Elite Pro\u2122"
	          ),
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { className: classes.link, to: "/boss" },
	            "BOSS\xAE"
	          ),
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { className: classes.link, to: "/compare_products" },
	            "Compare Products"
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: classes.column },
	          _react2.default.createElement(
	            "div",
	            { className: classes.section },
	            "Explore"
	          ),
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { className: classes.link, to: "/markets" },
	            "MLS Markets"
	          ),
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { className: classes.link, to: "/testimonials" },
	            "Happy Clients"
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: classes.column },
	          _react2.default.createElement(
	            "div",
	            { className: classes.section },
	            "Support"
	          ),
	          _react2.default.createElement(
	            "a",
	            {
	              className: classes.link,
	              href: "https://support.tryelevate.com/s/",
	              target: "_blank"
	            },
	            "Help Center"
	          ),
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { className: classes.link, to: "/webinars" },
	            "Training Webinars"
	          ),
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { className: classes.link, to: "/blog" },
	            "Blog"
	          ),
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { className: classes.link, to: "/dailymarketingtips" },
	            "Daily Marketing Tips"
	          ),
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { className: classes.link, to: "/free_educational_guides" },
	            "Free Educational Guides"
	          ),
	          _react2.default.createElement(
	            "a",
	            {
	              className: classes.link,
	              href: "https://tryelevate.com/terms-of-service",
	              target: "_blank"
	            },
	            "Terms of Service"
	          ),
	          _react2.default.createElement(
	            "a",
	            {
	              className: classes.link,
	              href: "https://elmstreet.com/terms",
	              target: "_blank"
	            },
	            "Pricing & Refund Policy"
	          ),
	          _react2.default.createElement(
	            "a",
	            {
	              className: classes.link,
	              href: "https://tryelevate.com/privacy",
	              target: "_blank"
	            },
	            "Privacy Policy"
	          ),
	          _react2.default.createElement(
	            "a",
	            {
	              className: classes.link,
	              href: "https://elmstreet.com/dmca",
	              target: "_blank"
	            },
	            "DMCA Notice"
	          ),
	          _react2.default.createElement(_SocialLinks2.default, { className: classes.social })
	        )
	      )
	    )
	  );
	};
	
	exports.default = (0, _withStyles2.default)(function (theme) {
	  var _root, _grid;
	
	  return {
	    root: (_root = {
	      display: "flex",
	      flexDirection: "column",
	      alignItems: "center",
	      justifyContent: "center",
	      width: "100%",
	      backgroundColor: "#5A5B5C",
	      padding: "48px 16px"
	
	    }, _root[theme.breakpoints[900]] = {
	      padding: "64px 24px"
	    }, _root[theme.breakpoints[1200]] = {
	      padding: "96px 64px"
	    }, _root),
	    grid: (_grid = {
	      width: "100%",
	      display: "grid",
	      gridTemplateColumns: "repeat(1, 1fr)",
	      gridColumnGap: "25px",
	      gridRowGap: "32px"
	
	    }, _grid[theme.breakpoints[900]] = {
	      gridTemplateColumns: "repeat(5, 1fr)"
	    }, _grid),
	    column: {
	      display: "flex",
	      flexDirection: "column"
	    },
	    copyright: {
	      maxWidth: "240px",
	      marginTop: "8px"
	    },
	    section: {
	      fontWeight: "700",
	      marginBottom: "8px",
	      color: "#FFF"
	    },
	    link: {
	      color: "#FFF",
	      textDecoration: "none",
	      marginTop: "15px",
	      lineHeight: "1.4"
	    },
	    social: {
	      marginTop: "24px"
	    }
	  };
	})(Footer);
	module.exports = exports["default"];

/***/ }),

/***/ 1546:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(15);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _classnames = __webpack_require__(4);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _withStyles = __webpack_require__(3);
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	var _Container = __webpack_require__(5);
	
	var _Container2 = _interopRequireDefault(_Container);
	
	var _elevate_tagw = __webpack_require__(81);
	
	var _elevate_tagw2 = _interopRequireDefault(_elevate_tagw);
	
	var _siteConfig = __webpack_require__(7);
	
	var _siteConfig2 = _interopRequireDefault(_siteConfig);
	
	var _SocialLinks = __webpack_require__(160);
	
	var _SocialLinks2 = _interopRequireDefault(_SocialLinks);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FooterWelcome = function FooterWelcome(_ref) {
	  var classes = _ref.classes;
	  return _react2.default.createElement(
	    "div",
	    { className: classes.root, style: { alignItems: "center" } },
	    _react2.default.createElement(
	      _Container2.default,
	      {
	        style: { textAlign: "center", marginLeft: "auto", marginRight: "auto" }
	      },
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: "/" },
	        _react2.default.createElement(
	          "div",
	          { style: { width: "170px", paddingBottom: "30px" } },
	          _react2.default.createElement("img", { src: _elevate_tagw2.default, width: "100%" })
	        )
	      )
	    )
	  );
	};
	
	exports.default = (0, _withStyles2.default)(function (theme) {
	  var _root, _grid;
	
	  return {
	    root: (_root = {
	      textAlign: "center",
	      justifyContent: "center",
	      width: "100%",
	      backgroundColor: "#5A5B5C",
	      padding: "35px 16px"
	
	    }, _root[theme.breakpoints[900]] = {
	      padding: "64px 24px",
	      textAlign: "center",
	      justifyContent: "center"
	    }, _root[theme.breakpoints[1200]] = {
	      padding: "56px 64px",
	      textAlign: "center",
	      justifyContent: "center"
	    }, _root),
	    grid: (_grid = {
	      width: "100%",
	      display: "grid",
	      gridTemplateColumns: "repeat(1, 1fr)",
	      gridColumnGap: "44px",
	      gridRowGap: "32px"
	
	    }, _grid[theme.breakpoints[900]] = {
	      gridTemplateColumns: "repeat(5, 1fr)"
	    }, _grid),
	    column: {
	      display: "flex",
	      flexDirection: "column"
	    },
	    copyright: {
	      maxWidth: "240px",
	      marginTop: "8px",
	      textAlign: "center"
	    },
	    section: {
	      fontWeight: "700",
	      marginBottom: "8px",
	      color: "#FFF"
	    },
	    link: {
	      color: "#FFF",
	      textDecoration: "none",
	      marginTop: "15px",
	      lineHeight: "1.4"
	    },
	    social: {
	      marginTop: "24px"
	    }
	  };
	})(FooterWelcome);
	module.exports = exports["default"];

/***/ }),

/***/ 1547:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(15);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _classnames = __webpack_require__(4);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _withStyles = __webpack_require__(3);
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	var _Container = __webpack_require__(5);
	
	var _Container2 = _interopRequireDefault(_Container);
	
	var _elevate_tagw = __webpack_require__(81);
	
	var _elevate_tagw2 = _interopRequireDefault(_elevate_tagw);
	
	var _siteConfig = __webpack_require__(7);
	
	var _siteConfig2 = _interopRequireDefault(_siteConfig);
	
	var _SocialLinks = __webpack_require__(160);
	
	var _SocialLinks2 = _interopRequireDefault(_SocialLinks);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FooterWelcome = function FooterWelcome(_ref) {
	  var classes = _ref.classes;
	  return _react2.default.createElement(
	    "div",
	    { className: classes.root, style: { alignItems: "center" } },
	    _react2.default.createElement(
	      _Container2.default,
	      { style: { textAlign: "center", marginLeft: "auto", marginRight: "auto" } },
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: "/" },
	        _react2.default.createElement(
	          "div",
	          { style: { width: "170px", paddingBottom: "30px" } },
	          _react2.default.createElement("img", { src: _elevate_tagw2.default, width: "100%" })
	        )
	      )
	    )
	  );
	};
	
	exports.default = (0, _withStyles2.default)(function (theme) {
	  var _root, _grid;
	
	  return {
	    root: (_root = {
	      textAlign: "center",
	      justifyContent: "center",
	      width: "100%",
	      backgroundColor: "#5A5B5C",
	      padding: "35px 16px"
	
	    }, _root[theme.breakpoints[900]] = {
	      padding: "64px 24px",
	      textAlign: "center",
	      justifyContent: "center"
	    }, _root[theme.breakpoints[1200]] = {
	      padding: "56px 64px",
	      textAlign: "center",
	      justifyContent: "center"
	    }, _root),
	    grid: (_grid = {
	      width: "100%",
	      display: "grid",
	      gridTemplateColumns: "repeat(1, 1fr)",
	      gridColumnGap: "44px",
	      gridRowGap: "32px"
	
	    }, _grid[theme.breakpoints[900]] = {
	      gridTemplateColumns: "repeat(5, 1fr)"
	    }, _grid),
	    column: {
	      display: "flex",
	      flexDirection: "column"
	    },
	    copyright: {
	      maxWidth: "240px",
	      marginTop: "8px",
	      textAlign: "center"
	    },
	    section: {
	      fontWeight: "700",
	      marginBottom: "8px",
	      color: "#FFF"
	    },
	    link: {
	      color: "#FFF",
	      textDecoration: "none",
	      marginTop: "15px",
	      lineHeight: "1.4"
	    },
	    social: {
	      marginTop: "24px"
	    }
	  };
	})(FooterWelcome);
	module.exports = exports["default"];

/***/ }),

/***/ 1243:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(15);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _withStyles = __webpack_require__(3);
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	var _Container = __webpack_require__(5);
	
	var _Container2 = _interopRequireDefault(_Container);
	
	var _classnames = __webpack_require__(4);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _elevate_tag = __webpack_require__(147);
	
	var _elevate_tag2 = _interopRequireDefault(_elevate_tag);
	
	var _HeaderNavDesktop = __webpack_require__(1244);
	
	var _HeaderNavDesktop2 = _interopRequireDefault(_HeaderNavDesktop);
	
	var _HeaderNavMobile = __webpack_require__(1245);
	
	var _HeaderNavMobile2 = _interopRequireDefault(_HeaderNavMobile);
	
	var _Dehaze = __webpack_require__(68);
	
	var _Dehaze2 = _interopRequireDefault(_Dehaze);
	
	var _noScroll = __webpack_require__(1142);
	
	var _noScroll2 = _interopRequireDefault(_noScroll);
	
	var _Logo = __webpack_require__(26);
	
	var _Logo2 = _interopRequireDefault(_Logo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Header = function (_Component) {
	  _inherits(Header, _Component);
	
	  function Header() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Header);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
	      isMenuOpen: false
	    }, _this.componentDidMount = function () {
	      console.log('make sure noscroll is off');
	      _noScroll2.default.off();
	    }, _this.onMenuOpen = function () {
	      _this.setState({ isMenuOpen: true });
	      _noScroll2.default.on();
	    }, _this.onMenuClose = function () {
	      _this.setState({ isMenuOpen: false });
	      _noScroll2.default.off();
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Header.prototype.render = function render() {
	    var classes = this.props.classes;
	
	
	    var thisPath = '';
	    if (this.props.currentLocation) {
	      thisPath = this.props.currentLocation.pathname;
	    }
	
	    return _react2.default.createElement(
	      "div",
	      null,
	      _react2.default.createElement(
	        "header",
	        { className: classes.root },
	        _react2.default.createElement(
	          _Container2.default,
	          null,
	          _react2.default.createElement(
	            "div",
	            { className: classes.inner },
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              { className: classes.logo, to: "/" },
	              _react2.default.createElement(
	                "div",
	                { style: { width: "160px" } },
	                _react2.default.createElement("img", { src: _elevate_tag2.default, width: "100%" })
	              )
	            ),
	            _react2.default.createElement(
	              "button",
	              { onClick: this.onMenuOpen, className: classes.navMobileIcon },
	              _react2.default.createElement(_Dehaze2.default, { size: 30, "aria-hidden": "true" })
	            ),
	            _react2.default.createElement(_HeaderNavDesktop2.default, { className: classes.navDesktop }),
	            _react2.default.createElement(_HeaderNavMobile2.default, {
	              className: (0, _classnames2.default)(classes.navMobile, this.state.isMenuOpen && classes.navMobileOpen),
	              onMenuClose: this.onMenuClose
	            }),
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              { to: "/get-started", className: classes.getStartedLink },
	              "Schedule Demo"
	            )
	          )
	        ),
	        _react2.default.createElement("button", {
	          onClick: this.onMenuClose,
	          className: (0, _classnames2.default)(classes.navMobileUnderlay, this.state.isMenuOpen && classes.navMobileUnderlayOpen)
	        })
	      ),
	      thisPath != '/leadgen' && thisPath != '/leadgen/' && _react2.default.createElement(
	        "div",
	        { className: classes.violator },
	        _react2.default.createElement(
	          "span",
	          { style: { fontWeight: "bold", fontSize: "14px" } },
	          "Try Elevate's Social Pro\xAE ",
	          _react2.default.createElement(
	            "span",
	            { style: { color: "#fdf134" } },
	            "FREE FOR 60-DAYS!"
	          )
	        ),
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: "/freetrial", target: "_blank", style: { color: "#fdf134", fontWeight: "bold", marginLeft: "8px", fontSize: "14px" } },
	          "Create Account"
	        )
	      )
	    );
	  };
	
	  return Header;
	}(_react.Component);
	
	exports.default = (0, _withStyles2.default)(function (theme) {
	  var _navDesktop, _navMobileIcon, _getStartedLink;
	
	  return {
	    root: {
	      zIndex: "9999",
	      position: "fixed",
	      top: "0",
	      display: "flex",
	      alignItems: "center",
	      width: "100%",
	      height: "80px",
	      backgroundColor: "#fff"
	    },
	    inner: {
	      display: "flex",
	      alignItems: "center",
	      justifyContent: "flex-end"
	    },
	    logo: {
	      marginRight: "auto"
	    },
	    navDesktop: (_navDesktop = {
	      display: "none"
	
	    }, _navDesktop[theme.breakpoints[900]] = {
	      display: "block"
	    }, _navDesktop),
	    navMobileIcon: (_navMobileIcon = {
	      margin: "10px 20px",
	      color: "#2E2E35",
	      display: "inline-flex",
	
	      "&:focus": {
	        outline: "1px solid #fff"
	      }
	
	    }, _navMobileIcon[theme.breakpoints[900]] = {
	      display: "none"
	    }, _navMobileIcon),
	    getStartedLink: (_getStartedLink = {
	      display: "none",
	      alignContent: "center",
	      justifyContent: "center",
	      fontSize: "14px",
	      fontWeight: "700",
	      letterSpacing: ".25px",
	      backgroundColor: theme.colors.secondary,
	      color: "#FFF",
	      textDecoration: "none",
	      padding: "14px 16px",
	      borderRadius: "4px"
	
	    }, _getStartedLink[theme.breakpoints[900]] = {
	      display: "block"
	    }, _getStartedLink),
	
	    navMobile: {
	      visibility: "hidden",
	      transform: "translateX(100vw)",
	      transition: "all .5s ease"
	    },
	
	    navMobileOpen: {
	      visibility: "visible",
	      transform: "translateX(calc(100vw - 280px))"
	    },
	
	    navMobileUnderlay: {
	      display: "flex",
	      width: "100%",
	      height: "100%",
	      position: "fixed",
	      visibility: "hidden",
	      top: "0",
	      right: "0",
	      bottom: "0",
	      left: "0",
	      backgroundColor: "rgba(0,0,0, 0.5)",
	      zIndex: "5"
	    },
	    navMobileUnderlayOpen: {
	      visibility: "visible"
	    },
	    violator: {
	      display: "none",
	      background: "#e72f6c",
	      color: "#FFFFFF",
	      position: "fixed",
	      top: "80px",
	      padding: "15px",
	      width: "100%",
	      textAlign: "center",
	      zIndex: "100",
	      lineHeight: "22px"
	    }
	  };
	})(Header);
	module.exports = exports["default"];

/***/ }),

/***/ 1592:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(15);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _withStyles = __webpack_require__(3);
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	var _Container = __webpack_require__(5);
	
	var _Container2 = _interopRequireDefault(_Container);
	
	var _classnames = __webpack_require__(4);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _HeaderNavDesktopWelcome = __webpack_require__(1391);
	
	var _HeaderNavDesktopWelcome2 = _interopRequireDefault(_HeaderNavDesktopWelcome);
	
	var _HeaderNavMobileWelcome = __webpack_require__(1392);
	
	var _HeaderNavMobileWelcome2 = _interopRequireDefault(_HeaderNavMobileWelcome);
	
	var _Dehaze = __webpack_require__(68);
	
	var _Dehaze2 = _interopRequireDefault(_Dehaze);
	
	var _noScroll = __webpack_require__(1142);
	
	var _noScroll2 = _interopRequireDefault(_noScroll);
	
	var _Logo = __webpack_require__(26);
	
	var _Logo2 = _interopRequireDefault(_Logo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var HeaderLander = function (_Component) {
	  _inherits(HeaderLander, _Component);
	
	  function HeaderLander() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, HeaderLander);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
	      isMenuOpen: false
	    }, _this.onMenuOpen = function () {
	      _this.setState({ isMenuOpen: true });
	      _noScroll2.default.on();
	    }, _this.onMenuClose = function () {
	      _this.setState({ isMenuOpen: false });
	      _noScroll2.default.off();
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  HeaderLander.prototype.render = function render() {
	    var classes = this.props.classes;
	
	    return _react2.default.createElement("header", { className: classes.root });
	  };
	
	  return HeaderLander;
	}(_react.Component);
	
	exports.default = (0, _withStyles2.default)(function (theme) {
	  var _navDesktop, _navMobileIcon, _getStartedLink;
	
	  return {
	    root: {
	      zIndex: "9999",
	      top: "0",
	      display: "flex",
	      alignItems: "center",
	      width: "100%",
	      backgroundColor: "#fff"
	    },
	    inner: {
	      display: "flex",
	      alignItems: "center",
	      justifyContent: "flex-end"
	    },
	    logo: {
	      marginRight: "auto"
	    },
	    navDesktop: (_navDesktop = {
	      display: "none"
	
	    }, _navDesktop[theme.breakpoints[900]] = {
	      display: "block"
	    }, _navDesktop),
	    navMobileIcon: (_navMobileIcon = {
	      margin: "10px 20px",
	      color: "#2E2E35",
	      display: "inline-flex",
	
	      "&:focus": {
	        outline: "1px solid #fff"
	      }
	
	    }, _navMobileIcon[theme.breakpoints[900]] = {
	      display: "none"
	    }, _navMobileIcon),
	    getStartedLink: (_getStartedLink = {
	      display: "none",
	      alignContent: "center",
	      justifyContent: "center",
	      fontSize: "14px",
	      fontWeight: "700",
	      letterSpacing: ".25px",
	      backgroundColor: theme.colors.secondary,
	      color: "#FFF",
	      textDecoration: "none",
	      padding: "14px 16px",
	      borderRadius: "4px"
	
	    }, _getStartedLink[theme.breakpoints[900]] = {
	      display: "block"
	    }, _getStartedLink),
	
	    navMobile: {
	      visibility: "hidden",
	      transform: "translateX(100vw)",
	      transition: "all .5s ease"
	    },
	
	    navMobileOpen: {
	      visibility: "visible",
	      transform: "translateX(calc(100vw - 280px))"
	    },
	
	    navMobileUnderlay: {
	      display: "flex",
	      width: "100%",
	      height: "100%",
	      position: "fixed",
	      visibility: "hidden",
	      top: "0",
	      right: "0",
	      bottom: "0",
	      left: "0",
	      backgroundColor: "rgba(0,0,0, 0.5)",
	      zIndex: "5"
	    },
	    navMobileUnderlayOpen: {
	      visibility: "visible"
	    }
	  };
	})(HeaderLander);
	module.exports = exports["default"];

/***/ }),

/***/ 1244:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(15);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _withStyles = __webpack_require__(3);
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	var _classnames = __webpack_require__(4);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _ArrowDropDown = __webpack_require__(76);
	
	var _ArrowDropDown2 = _interopRequireDefault(_ArrowDropDown);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HeaderNavDesktop = function HeaderNavDesktop(_ref) {
	  var classes = _ref.classes,
	      className = _ref.className;
	
	  return _react2.default.createElement(
	    "nav",
	    { className: (0, _classnames2.default)(classes.nav, className) },
	    _react2.default.createElement(
	      "div",
	      { className: classes.link },
	      _react2.default.createElement(
	        "div",
	        { className: classes.navItem },
	        "Products",
	        _react2.default.createElement(_ArrowDropDown2.default, { size: 20 })
	      ),
	      _react2.default.createElement(
	        "ul",
	        { className: classes.dropDown },
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { className: classes.listItemLink, to: "/elevate_at_a_glance" },
	          _react2.default.createElement(
	            "li",
	            { className: classes.listItem },
	            "Elevate At-A-Glance"
	          )
	        ),
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { className: classes.listItemLink, to: "/socialpro" },
	          _react2.default.createElement(
	            "li",
	            { className: classes.listItem },
	            "Social Pro\xAE"
	          )
	        ),
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { className: classes.listItemLink, to: "/elevatedms" },
	          _react2.default.createElement(
	            "li",
	            { className: classes.listItem },
	            "DMS\xAE"
	          )
	        ),
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { className: classes.listItemLink, to: "/dmsplus" },
	          _react2.default.createElement(
	            "li",
	            { className: classes.listItem },
	            "DMS Plus\xAE"
	          )
	        ),
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { className: classes.listItemLink, to: "/elite" },
	          _react2.default.createElement(
	            "li",
	            { className: classes.listItem },
	            "Elite\xAE"
	          )
	        ),
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { className: classes.listItemLink, to: "/elitepro" },
	          _react2.default.createElement(
	            "li",
	            { className: classes.listItem },
	            "Elite Pro\u2122"
	          )
	        ),
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { className: classes.listItemLink, to: "/boss" },
	          _react2.default.createElement(
	            "li",
	            { className: classes.listItem },
	            "BOSS\xAE"
	          )
	        ),
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { className: classes.listItemLink, to: "/compare_products" },
	          _react2.default.createElement(
	            "li",
	            { className: classes.listItem },
	            "Compare Products"
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      "div",
	      { className: classes.link },
	      _react2.default.createElement(
	        "div",
	        { className: classes.navItem },
	        "Explore",
	        _react2.default.createElement(_ArrowDropDown2.default, { size: 20 })
	      ),
	      _react2.default.createElement(
	        "ul",
	        { className: classes.dropDown },
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { className: classes.listItemLink, to: "/markets" },
	          _react2.default.createElement(
	            "li",
	            { className: classes.listItem },
	            "MLS Markets"
	          )
	        ),
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { className: classes.listItemLink, to: "/testimonials" },
	          _react2.default.createElement(
	            "li",
	            { className: classes.listItem },
	            "Happy Clients"
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      "div",
	      { className: classes.link },
	      _react2.default.createElement(
	        "div",
	        { className: classes.navItem },
	        "Support",
	        _react2.default.createElement(_ArrowDropDown2.default, { size: 20 })
	      ),
	      _react2.default.createElement(
	        "ul",
	        { className: classes.dropDown },
	        _react2.default.createElement(
	          "a",
	          {
	            className: classes.listItemLink,
	            href: "https://support.tryelevate.com/s/",
	            target: "_blank",
	            rel: "noreferrer noopener"
	          },
	          _react2.default.createElement(
	            "li",
	            { className: classes.listItem },
	            "Help Center"
	          )
	        ),
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { className: classes.listItemLink, to: "/webinars" },
	          _react2.default.createElement(
	            "li",
	            { className: classes.listItem },
	            "Training Webinars"
	          )
	        ),
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { className: classes.listItemLink, to: "/blog" },
	          _react2.default.createElement(
	            "li",
	            { className: classes.listItem },
	            "Blog"
	          )
	        ),
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { className: classes.listItemLink, to: "/dailymarketingtips" },
	          _react2.default.createElement(
	            "li",
	            { className: classes.listItem },
	            "Daily Marketing Tips"
	          )
	        ),
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { className: classes.listItemLink, to: "/free_educational_guides" },
	          _react2.default.createElement(
	            "li",
	            { className: classes.listItem },
	            "Free Educational Guides"
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = (0, _withStyles2.default)(function (theme) {
	  return {
	    nav: {
	      display: "flex",
	      justifyContent: "flex-end",
	      alignItems: "center",
	      marginRight: "16px",
	      alignSelf: "flex-end",
	
	      "& > * + *": {
	        marginLeft: "16px"
	      }
	    },
	    navItem: {
	      display: "flex"
	    },
	
	    link: {
	      float: "left",
	      padding: "1rem",
	      position: "relative",
	      textDecoration: "none",
	      fontSize: "18px",
	      fontWeight: "500",
	      color: "#64616E",
	      display: "block",
	
	      "&:hover": {
	        cursor: "pointer"
	      },
	
	      "&:hover $dropDown": {
	        visibility: "visible",
	        opacity: "1",
	        zIndex: "999",
	        transitionDelay: "0s, 0s, .3s"
	      }
	    },
	    listItem: {
	      clear: "both",
	      padding: "20px",
	      width: "100%",
	      fontSize: "15px",
	      borderTop: "1px solid rgba(236,236,236, .6)",
	
	      "&:hover": {
	        color: "#2E2E35",
	        background: "rgba(236,236,236, .4)"
	      }
	    },
	    listItemLink: {
	      color: "#64616E",
	      textDecoration: "none"
	    },
	    dropDown: {
	      background: "#FFF",
	      borderRadius: "6px",
	      boxShadow: "0 1px 3px 0 rgba(0,0,0,.05), 0 5px 20px 0 rgba(0,0,0,.15)",
	      listStyle: "none",
	      minWidth: "220px",
	      margin: "0",
	      paddingLeft: "0px",
	      visibility: "hidden",
	      opacity: "0",
	      position: "absolute",
	      marginTop: "1rem",
	      left: "0",
	      transform: "translateY(0%)",
	      transition: "all .3s ease-in-out",
	      overflow: "hidden",
	      zIndex: "999"
	    }
	  };
	})(HeaderNavDesktop);
	module.exports = exports["default"];

/***/ }),

/***/ 1391:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(15);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _withStyles = __webpack_require__(3);
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	var _classnames = __webpack_require__(4);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _ArrowDropDown = __webpack_require__(76);
	
	var _ArrowDropDown2 = _interopRequireDefault(_ArrowDropDown);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HeaderNavDesktopWelcome = function HeaderNavDesktopWelcome(_ref) {
	  var classes = _ref.classes,
	      className = _ref.className;
	
	  return _react2.default.createElement(
	    "nav",
	    { className: (0, _classnames2.default)(classes.nav, className) },
	    _react2.default.createElement(
	      "div",
	      { className: classes.link },
	      _react2.default.createElement(
	        "div",
	        { className: classes.navItem },
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { className: classes.listItemLink, to: "/events" },
	          "Upcoming Events"
	        )
	      )
	    ),
	    _react2.default.createElement(
	      "div",
	      { className: classes.link },
	      _react2.default.createElement(
	        "div",
	        { className: classes.navItem },
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { className: classes.listItemLink, to: "/webinars" },
	          "Webinars"
	        )
	      )
	    ),
	    _react2.default.createElement(
	      "div",
	      { className: classes.link },
	      _react2.default.createElement(
	        "div",
	        { className: classes.navItem },
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { className: classes.listItemLink, to: "https://support.tryelevate.com/s/", target: "_blank" },
	          "Help Center"
	        )
	      )
	    ),
	    _react2.default.createElement(
	      "div",
	      { className: classes.link },
	      _react2.default.createElement(
	        "div",
	        { className: classes.navItem },
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { className: classes.listItemLink, to: "/blog" },
	          "Blog"
	        )
	      )
	    )
	  );
	};
	
	exports.default = (0, _withStyles2.default)(function (theme) {
	  return {
	    nav: {
	      display: "flex",
	      justifyContent: "flex-end",
	      alignItems: "center",
	      marginRight: "16px",
	      alignSelf: "flex-end",
	
	      "& > * + *": {
	        marginLeft: "16px"
	      }
	    },
	    navItem: {
	      display: "flex"
	    },
	
	    link: {
	      float: "left",
	      padding: "1rem",
	      position: "relative",
	      textDecoration: "none",
	      fontSize: "18px",
	      fontWeight: "500",
	      color: "#64616E",
	      display: "block",
	
	      "&:hover": {
	        cursor: "pointer"
	      },
	
	      "&:hover $dropDown": {
	        visibility: "visible",
	        opacity: "1",
	        zIndex: "999",
	        transitionDelay: "0s, 0s, .3s"
	      }
	    },
	    listItem: {
	      clear: "both",
	      padding: "20px",
	      width: "100%",
	      fontSize: "15px",
	      borderTop: "1px solid rgba(236,236,236, .6)",
	
	      "&:hover": {
	        color: "#2E2E35",
	        background: "rgba(236,236,236, .4)"
	      }
	    },
	    listItemLink: {
	      color: "#64616E",
	      textDecoration: "none"
	    },
	    dropDown: {
	      background: "#FFF",
	      borderRadius: "6px",
	      boxShadow: "0 1px 3px 0 rgba(0,0,0,.05), 0 5px 20px 0 rgba(0,0,0,.15)",
	      listStyle: "none",
	      minWidth: "220px",
	      margin: "0",
	      paddingLeft: "0px",
	      visibility: "hidden",
	      opacity: "0",
	      position: "absolute",
	      marginTop: "1rem",
	      left: "0",
	      transform: "translateY(0%)",
	      transition: "all .3s ease-in-out",
	      overflow: "hidden",
	      zIndex: "999"
	    }
	  };
	})(HeaderNavDesktopWelcome);
	module.exports = exports["default"];

/***/ }),

/***/ 1245:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(15);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _withStyles = __webpack_require__(3);
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	var _classnames = __webpack_require__(4);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Close = __webpack_require__(77);
	
	var _Close2 = _interopRequireDefault(_Close);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HeaderNavMobile = function HeaderNavMobile(_ref) {
	  var classes = _ref.classes,
	      className = _ref.className,
	      onMenuClose = _ref.onMenuClose;
	
	  return _react2.default.createElement(
	    "nav",
	    { className: (0, _classnames2.default)(classes.nav, className) },
	    _react2.default.createElement(
	      "div",
	      { className: classes.topNav },
	      _react2.default.createElement(
	        "button",
	        { onClick: onMenuClose, className: classes.navMobileIcon },
	        _react2.default.createElement(_Close2.default, { size: 30, "aria-hidden": "true" })
	      )
	    ),
	    _react2.default.createElement(
	      "div",
	      { className: classes.link },
	      _react2.default.createElement(
	        "div",
	        { className: classes.navItem },
	        "Products"
	      ),
	      _react2.default.createElement(
	        "ul",
	        { className: classes.dropDown },
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { className: classes.listItemLink, to: "/elevate_at_a_glance" },
	          _react2.default.createElement(
	            "li",
	            { className: classes.listItem },
	            "Elevate At-A-Glance"
	          )
	        ),
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { className: classes.listItemLink, to: "/socialpro" },
	          _react2.default.createElement(
	            "li",
	            { className: classes.listItem },
	            "Social Pro\xAE"
	          )
	        ),
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { className: classes.listItemLink, to: "/elevatedms" },
	          _react2.default.createElement(
	            "li",
	            { className: classes.listItem },
	            "DMS\xAE"
	          )
	        ),
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { className: classes.listItemLink, to: "/dmsplus" },
	          _react2.default.createElement(
	            "li",
	            { className: classes.listItem },
	            "DMS Plus\xAE"
	          )
	        ),
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { className: classes.listItemLink, to: "/elite" },
	          _react2.default.createElement(
	            "li",
	            { className: classes.listItem },
	            "Elite\xAE"
	          )
	        ),
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { className: classes.listItemLink, to: "/elitepro" },
	          _react2.default.createElement(
	            "li",
	            { className: classes.listItem },
	            "Elite Pro\u2122"
	          )
	        ),
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { className: classes.listItemLink, to: "/boss" },
	          _react2.default.createElement(
	            "li",
	            { className: classes.listItem },
	            "BOSS\xAE"
	          )
	        ),
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { className: classes.listItemLink, to: "/compare_products" },
	          _react2.default.createElement(
	            "li",
	            { className: classes.listItem },
	            "Compare Products"
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      "div",
	      { className: classes.link },
	      _react2.default.createElement(
	        "div",
	        { className: classes.navItem },
	        "Explore"
	      ),
	      _react2.default.createElement(
	        "ul",
	        { className: classes.dropDown },
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { className: classes.listItemLink, to: "/markets" },
	          _react2.default.createElement(
	            "li",
	            { className: classes.listItem },
	            "MLS Markets"
	          )
	        ),
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { className: classes.listItemLink, to: "/testimonials" },
	          _react2.default.createElement(
	            "li",
	            { className: classes.listItem },
	            "Happy Clients"
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      "div",
	      { className: classes.link },
	      _react2.default.createElement(
	        "div",
	        { className: classes.navItem },
	        "Support"
	      ),
	      _react2.default.createElement(
	        "ul",
	        { className: classes.dropDown },
	        _react2.default.createElement(
	          "a",
	          {
	            className: classes.listItemLink,
	            href: "https://support.tryelevate.com/s/",
	            target: "_blank"
	          },
	          _react2.default.createElement(
	            "li",
	            { className: classes.listItem },
	            "Help Center"
	          )
	        ),
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { className: classes.listItemLink, to: "/webinars" },
	          _react2.default.createElement(
	            "li",
	            { className: classes.listItem },
	            "Training Webinars"
	          )
	        ),
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { className: classes.listItemLink, to: "/blog" },
	          _react2.default.createElement(
	            "li",
	            { className: classes.listItem },
	            "Blog"
	          )
	        ),
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { className: classes.listItemLink, to: "/dailymarketingtips" },
	          _react2.default.createElement(
	            "li",
	            { className: classes.listItem },
	            "Daily Marketing Tips"
	          )
	        ),
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { className: classes.listItemLink, to: "/free_educational_guides" },
	          _react2.default.createElement(
	            "li",
	            { className: classes.listItem },
	            "Free Educational Guides"
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _gatsbyLink2.default,
	      { to: "/get-started", className: classes.getStartedLink },
	      "Get Started"
	    )
	  );
	};
	
	exports.default = (0, _withStyles2.default)(function (theme) {
	  return {
	    nav: {
	      display: "flex",
	      flexDirection: "column",
	      maxWidth: "280px",
	      width: "100%",
	      paddingTop: "30px",
	      paddingBottom: "30px",
	      position: "fixed",
	      top: "0",
	      left: "0",
	      right: "0",
	      bottom: "0",
	      background: "#FFF",
	      zIndex: "9999999",
	      overflowY: "scroll",
	      boxShadow: "0 1px 3px 0 rgba(0,0,0,.1), 0 5px 20px 0 rgba(0,0,0,.2)"
	    },
	    topNav: {
	      display: "flex",
	      alignItems: "center"
	    },
	    navItem: {
	      display: "flex",
	      fontWeight: "600",
	      fontSize: "16px"
	    },
	
	    navMobileIcon: {
	      color: "#2E2E35",
	      position: "fixed",
	      display: "inline-flex",
	      top: "26px",
	      right: "26px",
	      zIndex: "1",
	
	      "&:focus": {
	        outline: "1px solid #fff"
	      }
	    },
	
	    link: {
	      paddingLeft: "20px",
	      padding: "1rem",
	      fontSize: "18px",
	      color: "#64616E",
	      borderBottom: "1px solid rgba(236,236,236, .6)"
	    },
	    listItem: {
	      padding: "15px",
	      width: "100%",
	      fontSize: "14px"
	    },
	    listItemLink: {
	      color: "#64616E",
	      textDecoration: "none"
	    },
	    dropDown: {
	      background: "#FFF",
	      display: "flex",
	      flexDirection: "column",
	      marginTop: "1rem"
	    },
	
	    getStartedLink: {
	      display: "flex",
	      flexShrink: "0",
	      alignContent: "center",
	      justifyContent: "center",
	      backgroundColor: "transparent",
	      fontSize: "14px",
	      fontWeight: "700",
	      letterSpacing: ".25px",
	      color: theme.colors.secondary,
	      border: "1px solid " + theme.colors.secondary,
	      textDecoration: "none",
	      padding: "12px 16px",
	      borderRadius: "4px",
	      alignSelf: "center",
	      marginTop: "20px"
	    }
	  };
	})(HeaderNavMobile);
	module.exports = exports["default"];

/***/ }),

/***/ 1392:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(15);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _withStyles = __webpack_require__(3);
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	var _classnames = __webpack_require__(4);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Close = __webpack_require__(77);
	
	var _Close2 = _interopRequireDefault(_Close);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HeaderNavMobileWelcome = function HeaderNavMobileWelcome(_ref) {
	  var classes = _ref.classes,
	      className = _ref.className,
	      onMenuClose = _ref.onMenuClose;
	
	  return _react2.default.createElement(
	    "nav",
	    { className: (0, _classnames2.default)(classes.nav, className) },
	    _react2.default.createElement(
	      "div",
	      { className: classes.topNav },
	      _react2.default.createElement(
	        "button",
	        { onClick: onMenuClose, className: classes.navMobileIcon },
	        _react2.default.createElement(_Close2.default, { size: 30, "aria-hidden": "true" })
	      )
	    ),
	    _react2.default.createElement(
	      "div",
	      { className: classes.link },
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { className: classes.listItemLink, to: "/events" },
	        _react2.default.createElement(
	          "div",
	          { className: classes.navItem },
	          "Upcoming Events"
	        )
	      )
	    ),
	    _react2.default.createElement(
	      "div",
	      { className: classes.link },
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { className: classes.listItemLink, to: "/webinars" },
	        _react2.default.createElement(
	          "div",
	          { className: classes.navItem },
	          "Webinars"
	        )
	      )
	    ),
	    _react2.default.createElement(
	      "div",
	      { className: classes.link },
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { className: classes.listItemLink, to: "https://support.tryelevate.com/s/", target: "_blank" },
	        _react2.default.createElement(
	          "div",
	          { className: classes.navItem },
	          "Help Center"
	        )
	      )
	    ),
	    _react2.default.createElement(
	      "div",
	      { className: classes.link },
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { className: classes.listItemLink, to: "/blog" },
	        _react2.default.createElement(
	          "div",
	          { className: classes.navItem },
	          "Blog"
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _gatsbyLink2.default,
	      { to: "/get-started", className: classes.getStartedLink },
	      "Get Started"
	    )
	  );
	};
	
	exports.default = (0, _withStyles2.default)(function (theme) {
	  return {
	    nav: {
	      display: "flex",
	      flexDirection: "column",
	      maxWidth: "280px",
	      width: "100%",
	      paddingTop: "30px",
	      paddingBottom: "30px",
	      position: "fixed",
	      top: "0",
	      left: "0",
	      right: "0",
	      bottom: "0",
	      background: "#FFF",
	      zIndex: "9999999",
	      overflowY: "scroll",
	      boxShadow: "0 1px 3px 0 rgba(0,0,0,.1), 0 5px 20px 0 rgba(0,0,0,.2)"
	    },
	    topNav: {
	      display: "flex",
	      alignItems: "center"
	    },
	    navItem: {
	      display: "flex",
	      fontWeight: "600",
	      fontSize: "16px"
	    },
	
	    navMobileIcon: {
	      color: "#2E2E35",
	      position: "fixed",
	      display: "inline-flex",
	      top: "26px",
	      right: "26px",
	      zIndex: "1",
	
	      "&:focus": {
	        outline: "1px solid #fff"
	      }
	    },
	
	    link: {
	      paddingLeft: "20px",
	      padding: "1rem",
	      fontSize: "18px",
	      color: "#64616E",
	      borderBottom: "1px solid rgba(236,236,236, .6)"
	    },
	    listItem: {
	      padding: "15px",
	      width: "100%",
	      fontSize: "14px"
	    },
	    listItemLink: {
	      color: "#64616E",
	      textDecoration: "none"
	    },
	    dropDown: {
	      background: "#FFF",
	      display: "flex",
	      flexDirection: "column",
	      marginTop: "1rem"
	    },
	
	    getStartedLink: {
	      display: "flex",
	      flexShrink: "0",
	      alignContent: "center",
	      justifyContent: "center",
	      backgroundColor: "transparent",
	      fontSize: "14px",
	      fontWeight: "700",
	      letterSpacing: ".25px",
	      color: theme.colors.secondary,
	      border: "1px solid " + theme.colors.secondary,
	      textDecoration: "none",
	      padding: "12px 16px",
	      borderRadius: "4px",
	      alignSelf: "center",
	      marginTop: "20px"
	    }
	  };
	})(HeaderNavMobileWelcome);
	module.exports = exports["default"];

/***/ }),

/***/ 1593:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(15);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _withStyles = __webpack_require__(3);
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	var _Container = __webpack_require__(5);
	
	var _Container2 = _interopRequireDefault(_Container);
	
	var _classnames = __webpack_require__(4);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _elevate_tag = __webpack_require__(147);
	
	var _elevate_tag2 = _interopRequireDefault(_elevate_tag);
	
	var _HeaderNavDesktopWelcome = __webpack_require__(1391);
	
	var _HeaderNavDesktopWelcome2 = _interopRequireDefault(_HeaderNavDesktopWelcome);
	
	var _HeaderNavMobileWelcome = __webpack_require__(1392);
	
	var _HeaderNavMobileWelcome2 = _interopRequireDefault(_HeaderNavMobileWelcome);
	
	var _Dehaze = __webpack_require__(68);
	
	var _Dehaze2 = _interopRequireDefault(_Dehaze);
	
	var _noScroll = __webpack_require__(1142);
	
	var _noScroll2 = _interopRequireDefault(_noScroll);
	
	var _Logo = __webpack_require__(26);
	
	var _Logo2 = _interopRequireDefault(_Logo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var HeaderWelcome = function (_Component) {
	  _inherits(HeaderWelcome, _Component);
	
	  function HeaderWelcome() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, HeaderWelcome);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
	      isMenuOpen: false
	    }, _this.onMenuOpen = function () {
	      _this.setState({ isMenuOpen: true });
	      _noScroll2.default.on();
	    }, _this.onMenuClose = function () {
	      _this.setState({ isMenuOpen: false });
	      _noScroll2.default.off();
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  HeaderWelcome.prototype.render = function render() {
	    var classes = this.props.classes;
	
	    return _react2.default.createElement(
	      "header",
	      { className: classes.root },
	      _react2.default.createElement(
	        _Container2.default,
	        null,
	        _react2.default.createElement(
	          "div",
	          { className: classes.inner },
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { className: classes.logo, to: "/" },
	            _react2.default.createElement(
	              "div",
	              { style: { width: "160px" } },
	              _react2.default.createElement("img", { src: _elevate_tag2.default, width: "100%" })
	            )
	          ),
	          _react2.default.createElement(
	            "button",
	            { onClick: this.onMenuOpen, className: classes.navMobileIcon },
	            _react2.default.createElement(_Dehaze2.default, { size: 30, "aria-hidden": "true" })
	          ),
	          _react2.default.createElement(_HeaderNavDesktopWelcome2.default, { className: classes.navDesktop }),
	          _react2.default.createElement(_HeaderNavMobileWelcome2.default, {
	            className: (0, _classnames2.default)(classes.navMobile, this.state.isMenuOpen && classes.navMobileOpen),
	            onMenuClose: this.onMenuClose
	          }),
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: "/get-started", className: classes.getStartedLink },
	            "Schedule Demo"
	          )
	        )
	      ),
	      _react2.default.createElement("button", {
	        onClick: this.onMenuClose,
	        className: (0, _classnames2.default)(classes.navMobileUnderlay, this.state.isMenuOpen && classes.navMobileUnderlayOpen)
	      })
	    );
	  };
	
	  return HeaderWelcome;
	}(_react.Component);
	
	exports.default = (0, _withStyles2.default)(function (theme) {
	  var _navDesktop, _navMobileIcon, _getStartedLink;
	
	  return {
	    root: {
	      zIndex: "9999",
	      position: "fixed",
	      top: "0",
	      display: "flex",
	      alignItems: "center",
	      width: "100%",
	      height: "80px",
	      backgroundColor: "#fff"
	    },
	    inner: {
	      display: "flex",
	      alignItems: "center",
	      justifyContent: "flex-end"
	    },
	    logo: {
	      marginRight: "auto"
	    },
	    navDesktop: (_navDesktop = {
	      display: "none"
	
	    }, _navDesktop[theme.breakpoints[900]] = {
	      display: "block"
	    }, _navDesktop),
	    navMobileIcon: (_navMobileIcon = {
	      margin: "10px 20px",
	      color: "#2E2E35",
	      display: "inline-flex",
	
	      "&:focus": {
	        outline: "1px solid #fff"
	      }
	
	    }, _navMobileIcon[theme.breakpoints[900]] = {
	      display: "none"
	    }, _navMobileIcon),
	    getStartedLink: (_getStartedLink = {
	      display: "none",
	      alignContent: "center",
	      justifyContent: "center",
	      fontSize: "14px",
	      fontWeight: "700",
	      letterSpacing: ".25px",
	      backgroundColor: theme.colors.secondary,
	      color: "#FFF",
	      textDecoration: "none",
	      padding: "14px 16px",
	      borderRadius: "4px"
	
	    }, _getStartedLink[theme.breakpoints[900]] = {
	      display: "block"
	    }, _getStartedLink),
	
	    navMobile: {
	      visibility: "hidden",
	      transform: "translateX(100vw)",
	      transition: "all .5s ease"
	    },
	
	    navMobileOpen: {
	      visibility: "visible",
	      transform: "translateX(calc(100vw - 280px))"
	    },
	
	    navMobileUnderlay: {
	      display: "flex",
	      width: "100%",
	      height: "100%",
	      position: "fixed",
	      visibility: "hidden",
	      top: "0",
	      right: "0",
	      bottom: "0",
	      left: "0",
	      backgroundColor: "rgba(0,0,0, 0.5)",
	      zIndex: "5"
	    },
	    navMobileUnderlayOpen: {
	      visibility: "visible"
	    }
	  };
	})(HeaderWelcome);
	module.exports = exports["default"];

/***/ }),

/***/ 160:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(4);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _withStyles = __webpack_require__(3);
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	var _Facebook = __webpack_require__(126);
	
	var _Facebook2 = _interopRequireDefault(_Facebook);
	
	var _Twitter = __webpack_require__(137);
	
	var _Twitter2 = _interopRequireDefault(_Twitter);
	
	var _LinkedIn = __webpack_require__(130);
	
	var _LinkedIn2 = _interopRequireDefault(_LinkedIn);
	
	var _Instagram = __webpack_require__(89);
	
	var _Instagram2 = _interopRequireDefault(_Instagram);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SocialLinks = function SocialLinks(_ref) {
	  var classes = _ref.classes,
	      className = _ref.className;
	
	  return _react2.default.createElement(
	    "div",
	    { className: (0, _classnames2.default)(classes.root, className) },
	    _react2.default.createElement(
	      "a",
	      {
	        className: (0, _classnames2.default)(classes.icon, classes.facebook),
	        href: "https://www.facebook.com/TryElevateRE/",
	        target: "_blank",
	        rel: "noreferrer noopener"
	      },
	      _react2.default.createElement(_Facebook2.default, { size: 32, color: "#FFF" })
	    ),
	    _react2.default.createElement(
	      "a",
	      {
	        className: (0, _classnames2.default)(classes.icon, classes.twitter),
	        href: "https://twitter.com/TryElevateRE",
	        target: "_blank",
	        rel: "noreferrer noopener"
	      },
	      _react2.default.createElement(_Twitter2.default, { size: 32, color: "#FFF" })
	    ),
	    _react2.default.createElement(
	      "a",
	      {
	        className: (0, _classnames2.default)(classes.icon, classes.linkedin),
	        href: "https://www.linkedin.com/company/elm-street-technology/?viewAsMember=true",
	        target: "_blank",
	        rel: "noreferrer noopener"
	      },
	      _react2.default.createElement(_LinkedIn2.default, { size: 32, color: "#FFF" })
	    ),
	    _react2.default.createElement(
	      "a",
	      {
	        className: (0, _classnames2.default)(classes.icon, classes.instagram),
	        href: "https://www.instagram.com/tryelevatere/",
	        target: "_blank",
	        rel: "noreferrer noopener"
	      },
	      _react2.default.createElement(_Instagram2.default, { size: 32, color: "#FFF" })
	    )
	  );
	};
	
	exports.default = (0, _withStyles2.default)(function (theme) {
	  return {
	    root: {
	      display: "flex",
	      alignItems: "center",
	      width: "100%"
	    },
	    icon: {
	      margin: "0 2px",
	
	      "&:hover": {
	        color: "inherit",
	        opacity: "0.6"
	      }
	    },
	    facebook: {
	      color: "#3b5998"
	    },
	    twitter: {
	      color: "#1da1f2"
	    },
	    linkedin: {
	      color: "#007bb5"
	    },
	    instagram: {
	      color: "#517fa4"
	    }
	  };
	})(SocialLinks);
	module.exports = exports["default"];

/***/ }),

/***/ 81:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 3111:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAMAAABEpIrGAAAAQlBMVEVaW1zxWVPyWFKVWljuWVNgWluJWlldWlvaWVRmWlt0WlqtWVfDWVXnWVNsWlp+WlmjWlefWle7WVa0WVbRWVThWVOEVsTuAAAAjklEQVQ4y+2SSw7CMAwFqeM4SZv+2/tfFQvhWBi3B0C87cxq9B6/uEgUb/mOuN8ZKwLges1phK6Dka54n5mzkXufl8r8ZdTi8TSACDAkRwjI/G1g+ObzybwZ52z5dDDXwTGZQptwMbbPXgtaARdbyEx7aSGd6ZWq4dIrScLsC7m0hgjOUHtGCs74Ov+1PQFWQQQL12sCJAAAAABJRU5ErkJggg=="

/***/ }),

/***/ 1642:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(8);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _ThemeProvider = __webpack_require__(1878);
	
	var _ThemeProvider2 = _interopRequireDefault(_ThemeProvider);
	
	var _siteConfig = __webpack_require__(7);
	
	var _siteConfig2 = _interopRequireDefault(_siteConfig);
	
	var _Header = __webpack_require__(1243);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _HeaderWelcome = __webpack_require__(1593);
	
	var _HeaderWelcome2 = _interopRequireDefault(_HeaderWelcome);
	
	var _HeaderLander = __webpack_require__(1592);
	
	var _HeaderLander2 = _interopRequireDefault(_HeaderLander);
	
	var _Footer = __webpack_require__(1237);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _FooterWelcome = __webpack_require__(1547);
	
	var _FooterWelcome2 = _interopRequireDefault(_FooterWelcome);
	
	var _FooterLander = __webpack_require__(1546);
	
	var _FooterLander2 = _interopRequireDefault(_FooterLander);
	
	var _favicon = __webpack_require__(3111);
	
	var _favicon2 = _interopRequireDefault(_favicon);
	
	var _withStyles = __webpack_require__(3);
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Template = function Template(_ref) {
	  var children = _ref.children,
	      classes = _ref.classes,
	      location = _ref.location;
	
	  if (typeof window !== 'undefined') {
	    if (window.drift) {
	      //console.log('resetting drift');
	      window.drift.reset();
	    }
	  }
	
	  function ChooseFooter() {
	    if (location.pathname == "/socialmediamarketingguide/" || location.pathname == "/socialmediamarketingguide" || location.pathname == "/your2021marketingguide/" || location.pathname == "/your2021marketingguide" || location.pathname == "/yourmarketingguide/" || location.pathname == "/yourmarketingguide" || location.pathname == "/emailproguide/" || location.pathname == "/emailproguide" || location.pathname == "/kardashian/" || location.pathname == "/kardashian" || location.pathname == "/singlepropertywebsites/" || location.pathname == "/singlepropertywebsites" || location.pathname == "/sellerleads/" || location.pathname == "/sellerleads" || location.pathname == "/leadgen/" || location.pathname == "/leadgen" || location.pathname == "/emailmarketingguide/" || location.pathname == "/emailmarketingguide" || location.pathname == "/brokeragetechchecklist/" || location.pathname == "/brokeragetechchecklist" || location.pathname == "/listings/" || location.pathname == "/listings" || location.pathname == "/listingsguide/" || location.pathname == "/listingsguide" || location.pathname == "/smstour/" || location.pathname == "/smstour" || location.pathname == "/bloggingguide/" || location.pathname == "/bloggingguide" || location.pathname == "/gettingsocialwithdylan/" || location.pathname == "/gettingsocialwithdylan" || location.pathname == "/30daymarketingchallenge/" || location.pathname == "/30daymarketingchallenge" || location.pathname == "/personalgrowthplan/" || location.pathname == "/personalgrowthplan" || location.pathname == "/beachesmls/" || location.pathname == "/beachesmls" || location.pathname == "/leadgenguide/" || location.pathname == "/leadgenguide") {
	      return _react2.default.createElement(_FooterLander2.default, null);
	    }
	
	    if (location.pathname == "/welcome" || location.pathname == "/welcome/" || location.pathname == "/welcome_elite" || location.pathname == "/welcome_elite/") {
	      return _react2.default.createElement(_FooterWelcome2.default, null);
	    }
	
	    return _react2.default.createElement(_Footer2.default, null);
	  }
	
	  function ChooseHeader() {
	    if (location.pathname == "/socialmediamarketingguide/" || location.pathname == "/socialmediamarketingguide" || location.pathname == "/your2021marketingguide/" || location.pathname == "/your2021marketingguide" || location.pathname == "/yourmarketingguide/" || location.pathname == "/yourmarketingguide" || location.pathname == "/emailproguide/" || location.pathname == "/emailproguide" || location.pathname == "/kardashian/" || location.pathname == "/kardashian" || location.pathname == "/singlepropertywebsites/" || location.pathname == "/singlepropertywebsites" || location.pathname == "/sellerleads/" || location.pathname == "/sellerleads" || location.pathname == "/leadgen/" || location.pathname == "/leadgen" || location.pathname == "/emailmarketingguide/" || location.pathname == "/emailmarketingguide" || location.pathname == "/listings/" || location.pathname == "/listings" || location.pathname == "/listingsguide/" || location.pathname == "/listingsguide" || location.pathname == "/brokeragetechchecklist/" || location.pathname == "/brokeragetechchecklist" || location.pathname == "/smstour/" || location.pathname == "/smstour" || location.pathname == "/bloggingguide/" || location.pathname == "/bloggingguide" || location.pathname == "/gettingsocialwithdylan/" || location.pathname == "/gettingsocialwithdylan" || location.pathname == "/30daymarketingchallenge/" || location.pathname == "/30daymarketingchallenge" || location.pathname == "/personalgrowthplan/" || location.pathname == "/personalgrowthplan" || location.pathname == "/beachesmls/" || location.pathname == "/beachesmls" || location.pathname == "/success/" || location.pathname == "/success" || location.pathname == "/leadgenguide/" || location.pathname == "/leadgenguide") {
	      return _react2.default.createElement(_HeaderLander2.default, null);
	    }
	
	    if (location.pathname == "/welcome" || location.pathname == "/welcome/" || location.pathname == "/welcome_elite" || location.pathname == "/welcome_elite/") {
	      return _react2.default.createElement(_HeaderWelcome2.default, null);
	    }
	
	    return _react2.default.createElement(_Header2.default, { currentLocation: location });
	  }
	
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(
	      _reactHelmet2.default,
	      null,
	      _react2.default.createElement(
	        "title",
	        null,
	        _siteConfig2.default.siteTitle
	      ),
	      _react2.default.createElement("meta", { charSet: "utf-8" }),
	      _react2.default.createElement("meta", { name: "viewport", content: "width=device-width, initial-scale=1" }),
	      _react2.default.createElement("link", { rel: "icon", href: _favicon2.default }),
	      _react2.default.createElement("meta", { name: "description", content: _siteConfig2.default.siteDescription }),
	      _react2.default.createElement("meta", { property: "og:title", content: _siteConfig2.default.siteTitle }),
	      _react2.default.createElement("meta", { property: "og:url", content: _siteConfig2.default.siteUrl }),
	      _react2.default.createElement("meta", { property: "og:locale", content: "en_US" }),
	      _react2.default.createElement("meta", { property: "og:type", content: "website" }),
	      _react2.default.createElement("meta", { property: "og:site_name", content: _siteConfig2.default.siteTitle }),
	      _react2.default.createElement("link", { href: "https://fonts.googleapis.com/css?family=Open+Sans:400,600,700,800", rel: "stylesheet" })
	    ),
	    _react2.default.createElement(
	      _ThemeProvider2.default,
	      null,
	      _react2.default.createElement(
	        "div",
	        { className: classes.root },
	        _react2.default.createElement(ChooseHeader, null),
	        _react2.default.createElement(
	          "div",
	          { className: classes.children },
	          children()
	        ),
	        _react2.default.createElement(ChooseFooter, null)
	      )
	    )
	  );
	};
	
	exports.default = (0, _withStyles2.default)(function (theme) {
	  return {
	    "@global": {
	      body: {
	        background: "#fff",
	        color: "#2E2E35"
	      }
	    },
	    root: {
	      display: "flex",
	      flexDirection: "column",
	      width: "100%",
	      minHeight: "100vh"
	    },
	    children: {
	      flex: "1",
	      marginTop: "80px" // Header height
	    }
	  };
	})(Template);
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-index-js-4c8f4cca7d12c6d51329.js